import React from 'react';
import { useNavigate } from 'react-router-dom';

const LessonTaskModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm mx-4">
        <h2 className="text-xl font-semibold mb-4">Complete the lesson first!</h2>
        <div className="space-y-4 text-gray-700">
          <p>
            When you finish this lesson on the Lesson Tree tab, this task will automatically be
            marked as done.
          </p>
        </div>
        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-colors"
          >
            Got it!
          </button>
          <button
            onClick={() => navigate('/progress-tree')}
            className="px-4 py-2 outline-solid outline-purple-500 text-purple-500 rounded-lg hover:bg-purple-600 hover:text-white transition-colors"
          >
            Go to lesson tree
          </button>
        </div>
      </div>
    </div>
  );
};

export default LessonTaskModal;
